import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

export type MutationFnType = typeof mutationFn;

const RESOURCE = '/parkings/:parkingId/allow-list/:listId/';

export interface DTO {
    parkingId: string;
    listId: string;
}

const mutationFn = ({ parkingId, listId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { parkingId, listId }));
};

interface UseCreateAdditionalServicesOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}

export const useMutationHook = (options: UseCreateAdditionalServicesOptions) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteAllowList };
